import React, { useState } from 'react'

const AddedToPlaylist = ({ color = '#fff', hoverColor = '#bbfa33', imgClass = '' }) => {
  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={imgClass}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      viewBox="0 0 22.749 15.715"
    >
      <path
        data-name="Path 929"
        d="M18.013 6H3v2.5h15.013z"
        style={{ fill: isHovered ? hoverColor : color }}
        transform="translate(-3 -6)"
      />
      <path
        data-name="Path 930"
        d="M18.013 10H3v2.5h15.013z"
        transform="translate(-3 -4.996)"
        style={{ fill: isHovered ? hoverColor : color }}
      />
      <path
        data-name="Path 931"
        d="M3 14h10.009v2.5H3z"
        transform="translate(-3 -3.991)"
        style={{ fill: isHovered ? hoverColor : color }}
      />
      <path
        data-name="Path 932"
        d="m11.991 15.913 1.77-1.77 2.653 2.657 5.308-5.308 1.769 1.769-7.077 7.077z"
        transform="translate(-.742 -4.621)"
        style={{ fill: isHovered ? hoverColor : color }}
      />
    </svg>
  )
}

export default AddedToPlaylist
